<script>
import parse from 'date-fns/parse';
import isAfter from 'date-fns/isAfter';
import { dateTimeInputFormat } from '@/utils/date';
import VSvgIcon from '@/components/UI/VSvgIcon.vue';
import { statusSymbol } from '@/utils/statusSymbol';

const getState = ({ status, subState, optinPossible, promotionType, start, end }) => {
  switch (status) {
    case 1:
      return 'reserved'; // PENDING
    case 4:
      return 'inactive_retrying'; // SUSPEND_RETRY
    case 5: {
      // SUSPEND
      const sOk = !!start && !!end;
      const startedAfterEnd = sOk && isAfter(parse(start, dateTimeInputFormat, new Date()), parse(end, dateTimeInputFormat, new Date()));
      return startedAfterEnd ? 'failed' : 'terminated';
    }
    default: {
      if (status === 2 && subState === 2) return 'locked'; // ACTIVE + LOCKED
      if (status === 2 || status === 3) {
        // ACTIVE / ALERT
        if (promotionType === 1 && optinPossible) return 'opt_in_possible';
        return 'active';
      }
      return null;
    }
  }
};

export default {
  name: 'StateIcon',
  functional: true,

  components: {
    VSvgIcon,
  },

  props: {
    status: { type: Number, required: true },
    subState: { type: Number, default: null },
    optinPossible: { type: Boolean },
    promotionType: { type: Number, default: null },
    start: { type: String, default: null },
    end: { type: String, default: null },
  },

  render: (h, ctx) => {
    const state = getState(ctx.props);
    const title = ctx.parent.$t(`internalstock.status_${state}`);
    const srOnly = h('span', { class: 'col-xl-sr-only col-l-sr-only col-m-sr-only col-s-sr-only' }, title);
    const symbol = statusSymbol(state, 'clock');

    const svgIcon = h(VSvgIcon, {
      props: {
        name: symbol,
        size: 'middle',
        variant: 'outlined',
        pointerEvents: 'auto',
      },
      class: [`svg-icon-${statusSymbol(state)}`, 'state', symbol, 'col-xs-hide'],
      attrs: {
        role: 'img',
        title,
        'aria-hidden': true,
      },
    });

    return [srOnly, svgIcon];
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';

.state.icon {
  width: 1em;
  height: 1em;
  font-size: 27px;
  fill: currentColor;
}

.svg-icon-success,
.svg-icon-confirm {
  color: #548d1c !important;
}

.svg-icon-error,
.svg-icon-cancel {
  color: #a10000 !important;
}

.svg-icon-lock {
  color: #007faf !important;
}

.svg-icon-clock {
  color: #767676 !important;
}
</style>
